import { call, fork, select, put, takeLatest } from 'redux-saga/effects';

import { fetchEfectores, fetchEfectoresByPractice, importEfectores } from '../api';

import { efectorlistActions } from './actions';
import { getEfectorListById, getCurrentEfectorList } from './selectors';

export function* loadEfectorList({payload}) {
  const { efectorListId } = payload;

  const efectorList = yield select(getEfectorListById, efectorListId);

  if ( efectorList && efectorList.isNew ) {
    yield call(fetchEfectores, efectorListId, efectorList.filters);
  }
}

export function* loadEfectorListByPractice({payload}) {
  const { efectorListId } = payload;

  const efectorList = yield select(getEfectorListById, efectorListId);

  if ( efectorList && efectorList.isNew ) {
    yield call(fetchEfectoresByPractice, efectorListId, efectorList.filters);
  }
}



export function* loadNextResults() {
  const efectorList = yield select(getCurrentEfectorList);

  if (efectorList.hasNextPageInStore) {
      yield put(efectorlistActions.updatePagination(efectorList.currentPage + 1));
  }
  else if (efectorList && efectorList.nextUrl) {
      yield call(fetchEfectores, efectorList.id, { url: efectorList.nextUrl, filtros: efectorList.filters } );
  }
}

export function* loadPrevResults() {
  const efectorList = yield select(getCurrentEfectorList);

  if (efectorList.hasPrevPage) {
      yield put(efectorlistActions.updatePagination(efectorList.currentPage - 1));
  }
}


//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadEfectorList() {
  yield takeLatest(efectorlistActions.LOAD_EFECTORES, loadEfectorList);
}

export function* watchLoadEfectorListByPractice() {
  yield takeLatest(efectorlistActions.LOAD_EFECTORES_BY_PRACTICE, loadEfectorListByPractice);
}


export function* watchLoadNextResults() {
  yield takeLatest(efectorlistActions.LOAD_NEXT_RESULTS, loadNextResults);
}

export function* watchLoadPrevResults() {
  yield takeLatest(efectorlistActions.LOAD_PREV_RESULTS, loadPrevResults);
}


//=====================================
//  ROOT
//-------------------------------------

export const efectorlistSagas = [
  fork(watchLoadEfectorList),
  fork(watchLoadEfectorListByPractice),
];
